// extracted by mini-css-extract-plugin
export default {"melodyVideo":"DN-z","isFullWidth":"EN-z","landingPageVideo":"FN-z","play":"GN-z","iframeVideo":"HN-z","playHidden":"IN-z","fullwidth":"JN-z"};